import { toSafeString } from '@shared/utils';
import getPieveAuthToken from '@/lib/auth/getPieveAuthToken.js';
import upsertThreadOptimistic from '@/redux/actions/pieveActions/upsertThreadOptimistic.js';
import createRequestFailure from '@/redux/requests/lib/createRequestFailure.js';
import { getThread as getThreadRequest } from '@/redux/requests/threadsRequests.js';

const inFlightHydrationsByThreadId = new Map();

const hydrateThreadMeta = ({ threadId } = {}) => {
  const safeThreadId = toSafeString(threadId);

  return async (dispatch) => {
    if (!safeThreadId) {
      return createRequestFailure({ message: 'threadId is required' });
    }

    if (inFlightHydrationsByThreadId.has(safeThreadId)) {
      return inFlightHydrationsByThreadId.get(safeThreadId);
    }

    const hydratePromise = (async () => {
      const authToken = await getPieveAuthToken();
      const threadRes = await getThreadRequest({
        threadId: safeThreadId,
        authToken
      });

      if (!threadRes?.success) {
        return threadRes || createRequestFailure({ message: 'Failed to load task' });
      }

      const thread = threadRes?.data?.thread || threadRes?.data || null;

      if (!thread || typeof thread !== 'object') {
        return createRequestFailure({ message: 'Task payload is missing' });
      }

      dispatch(
        upsertThreadOptimistic({
          thread
        })
      );

      return {
        success: true,
        data: {
          threadId: safeThreadId,
          thread
        }
      };
    })();

    inFlightHydrationsByThreadId.set(safeThreadId, hydratePromise);

    try {
      return await hydratePromise;
    } finally {
      inFlightHydrationsByThreadId.delete(safeThreadId);
    }
  };
};

export default hydrateThreadMeta;
